var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EMutualFundOrderTabs } from "@domains/features/ActivityBook/OrderBook/MutualFund/entities/IMutualFundTransactionsCommonEntity";
import { EDescriptiveMandateType, } from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/ManagePortfolio/MutualFundOrders";
export var AllKebabMenuItems = {
    RESEND_CONSENT_REQUEST: {
        icon: "edel-icon-calendar-mob",
        text: "Resend Consent Request",
    },
    VIEW_DETAILS: {
        icon: "edel-icon-product-book",
        text: "View Details",
    },
    CANCEL: {
        icon: "edel-icon-editicon-underline",
        text: "Cancel",
    },
    MODIFY: {
        icon: "edel-icon-editicon-underline",
        text: "Modify",
    },
    DUPLICATE: {
        icon: "edel-icon-editicon-underline",
        text: "Duplicate",
    },
    RESEND_PAYMENT_LINK: {
        icon: "edel-icon-editicon-underline",
        text: "Resend Payment Link",
    },
    PLACE_ORDER_AGAIN: {
        icon: "edel-icon-editicon-underline",
        text: "Place Order Again",
    },
    VIEW_ALL_STPS: {
        icon: "edel-icon-editicon-underline",
        text: "View All STPs",
    },
    VIEW_ALL_SWPS: {
        icon: "edel-icon-editicon-underline",
        text: "View All SWPs",
    },
    REDEEM: {
        icon: "edel-icon-transfer",
        text: "Redeem",
    },
    START_SWP: {
        icon: "edel-icon-transfer",
        text: "Start SWP",
    },
    START_STP: {
        icon: "edel-icon-transfer",
        text: "Start STP",
    },
    SWITCH_FUND: {
        icon: "edel-icon-transfer",
        text: "Switch Fund",
    },
    PAUSE: {
        icon: "edel-icon-transfer",
        text: "Pause",
    },
    CANCEL_SIP: {
        icon: "edel-icon-transfer",
        text: "Cancel SIP",
    },
    RESUME: {
        icon: "edel-icon-transfer",
        text: "Resume",
    },
    VIEW_MANDATE_CALENDAR: {
        icon: "edel-icon-calendar-mob",
        text: "View Mandate Calendar",
    },
    AUTHENTICATE: {
        icon: "edel-icon-transfer",
        text: "Authenticate",
    },
    CREATE_NEW_MANDATE: {
        icon: "edel-icon-calendar-mob",
        text: "Create New Mandate",
    },
    VIEW_TRANSACTION: {
        icon: "edel-icon-product-book",
        text: "View Transactions",
    },
};
var normalizeDisplayStatus = function (displayStatus, tab) {
    if (!/completed/i.test(displayStatus)) {
        return displayStatus;
    }
    // Return based on tab
    var isSpecificTab = tab === EMutualFundOrderTabs.STPs ||
        tab === EMutualFundOrderTabs.SWPs ||
        tab === EMutualFundOrderTabs.SIPs;
    // setting display status as order completed for ALL Transactions tab and completed for rest of the tabs(SIPs,STPs,SWPs) to match the CTA sheet provided
    return isSpecificTab ? "COMPLETED" : "ORDER COMPLETED";
};
export var generateKebabMenuItems = function (selectedTransactionTab, allTransactionsDataOrder, selectedKebabMenuItemTrxId) {
    var _a;
    var _b, _c;
    // we are only getting display status as completed from the be the "order completed" renaming is done to get correct CTA mapping
    // as per the CTA sheet provided, we need to keep order completed for all transaction and completed for rest of the tabs
    var allTransactionData = allTransactionsDataOrder.map(function (item) { return (__assign(__assign({}, item), { displayStatus: normalizeDisplayStatus(item.displayStatus, selectedTransactionTab) })); });
    var selectedRowData = allTransactionData.find(function (item) { return (item === null || item === void 0 ? void 0 : item.trxId) === selectedKebabMenuItemTrxId; });
    // setting up possible kebab menu items as per transaction Type and transationc status
    var transactionTypeTransactionStatusMap = {
        SIP: {
            "CONSENT PENDING": [
                AllKebabMenuItems.RESEND_CONSENT_REQUEST,
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.CANCEL,
                AllKebabMenuItems.MODIFY,
            ],
            "ORDER IN PROGRESS": [AllKebabMenuItems.VIEW_DETAILS],
            "ORDER ACCEPTED": [AllKebabMenuItems.VIEW_DETAILS],
            "ORDER REJECTED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "ORDER CANCELLED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "CONSENT REJECTED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "PAYMENT PENDING": [
                AllKebabMenuItems.RESEND_PAYMENT_LINK,
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.CANCEL,
                AllKebabMenuItems.MODIFY,
            ],
            "ORDER COMPLETED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.PLACE_ORDER_AGAIN,
                AllKebabMenuItems.START_STP,
                AllKebabMenuItems.START_SWP,
                AllKebabMenuItems.SWITCH_FUND,
            ],
            "PAYMENT FAILED": [
                AllKebabMenuItems.RESEND_PAYMENT_LINK,
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.CANCEL,
                AllKebabMenuItems.MODIFY,
            ],
            ACTIVE: [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.REDEEM,
                AllKebabMenuItems.START_SWP,
                AllKebabMenuItems.START_STP,
                AllKebabMenuItems.SWITCH_FUND,
                AllKebabMenuItems.MODIFY,
                AllKebabMenuItems.PAUSE,
                AllKebabMenuItems.CANCEL_SIP,
            ],
            PAUSED: [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.REDEEM,
                AllKebabMenuItems.START_SWP,
                AllKebabMenuItems.START_STP,
                AllKebabMenuItems.SWITCH_FUND,
                AllKebabMenuItems.MODIFY,
                AllKebabMenuItems.RESUME,
                AllKebabMenuItems.CANCEL_SIP,
            ],
            CANCELLED: [AllKebabMenuItems.VIEW_DETAILS, AllKebabMenuItems.DUPLICATE],
            COMPLETED: [AllKebabMenuItems.VIEW_DETAILS, AllKebabMenuItems.DUPLICATE],
        },
        STP: {
            "CONSENT PENDING": [
                AllKebabMenuItems.RESEND_CONSENT_REQUEST,
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.CANCEL,
                AllKebabMenuItems.MODIFY,
            ],
            "CONSENT REJECTED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "ORDER IN PROGRESS": [AllKebabMenuItems.VIEW_DETAILS],
            "ORDER ACCEPTED": [AllKebabMenuItems.VIEW_DETAILS],
            "ORDER REJECTED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "ORDER CANCELLED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "ORDER COMPLETED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.VIEW_ALL_STPS,
            ],
            ACTIVE: [AllKebabMenuItems.VIEW_DETAILS, AllKebabMenuItems.CANCEL],
            CANCELLED: [AllKebabMenuItems.VIEW_DETAILS, AllKebabMenuItems.DUPLICATE],
            COMPLETED: [AllKebabMenuItems.VIEW_DETAILS, AllKebabMenuItems.DUPLICATE],
        },
        SWP: {
            "CONSENT PENDING": [
                AllKebabMenuItems.RESEND_CONSENT_REQUEST,
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.CANCEL,
                AllKebabMenuItems.MODIFY,
            ],
            "CONSENT REJECTED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "ORDER IN PROGRESS": [AllKebabMenuItems.VIEW_DETAILS],
            "ORDER ACCEPTED": [AllKebabMenuItems.VIEW_DETAILS],
            "ORDER COMPLETED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.VIEW_ALL_SWPS,
            ],
            "ORDER REJECTED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "ORDER CANCELLED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            ACTIVE: [AllKebabMenuItems.VIEW_DETAILS, AllKebabMenuItems.CANCEL],
            CANCELLED: [AllKebabMenuItems.VIEW_DETAILS, AllKebabMenuItems.DUPLICATE],
            COMPLETED: [AllKebabMenuItems.VIEW_DETAILS, AllKebabMenuItems.DUPLICATE],
        },
        Lumpsum: {
            "CONSENT PENDING": [
                AllKebabMenuItems.RESEND_CONSENT_REQUEST,
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.CANCEL,
                AllKebabMenuItems.MODIFY,
            ],
            "ORDER IN PROGRESS": [AllKebabMenuItems.VIEW_DETAILS],
            "ORDER ACCEPTED": [AllKebabMenuItems.VIEW_DETAILS],
            "CONSENT REJECTED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "ORDER CANCELLED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "ORDER REJECTED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "PAYMENT PENDING": [
                AllKebabMenuItems.RESEND_PAYMENT_LINK,
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.CANCEL,
                AllKebabMenuItems.MODIFY,
            ],
            "ORDER COMPLETED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.PLACE_ORDER_AGAIN,
                AllKebabMenuItems.START_STP,
                AllKebabMenuItems.START_SWP,
                AllKebabMenuItems.SWITCH_FUND,
            ],
            "PAYMENT FAILED": [
                AllKebabMenuItems.RESEND_PAYMENT_LINK,
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.CANCEL,
                AllKebabMenuItems.MODIFY,
            ],
        },
        Redeem: {
            "CONSENT PENDING": [
                AllKebabMenuItems.RESEND_CONSENT_REQUEST,
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.CANCEL,
                AllKebabMenuItems.MODIFY,
            ],
            "CONSENT REJECTED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "ORDER IN PROGRESS": [AllKebabMenuItems.VIEW_DETAILS],
            "ORDER ACCEPTED": [AllKebabMenuItems.VIEW_DETAILS],
            "ORDER REJECTED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "ORDER CANCELLED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "ORDER COMPLETED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.PLACE_ORDER_AGAIN,
            ],
        },
        SWITCH: {
            "CONSENT PENDING": [
                AllKebabMenuItems.RESEND_CONSENT_REQUEST,
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.CANCEL,
                AllKebabMenuItems.MODIFY,
            ],
            "CONSENT REJECTED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "PAYMENT PENDING": [
                AllKebabMenuItems.RESEND_PAYMENT_LINK,
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.CANCEL,
                AllKebabMenuItems.MODIFY,
            ],
            "ORDER IN PROGRESS": [AllKebabMenuItems.VIEW_DETAILS],
            "ORDER ACCEPTED": [AllKebabMenuItems.VIEW_DETAILS],
            "ORDER REJECTED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "ORDER CANCELLED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.DUPLICATE,
            ],
            "ORDER COMPLETED": [
                AllKebabMenuItems.VIEW_DETAILS,
                AllKebabMenuItems.PLACE_ORDER_AGAIN,
                AllKebabMenuItems.START_STP,
                AllKebabMenuItems.START_SWP,
                AllKebabMenuItems.SWITCH_FUND,
            ],
        },
    };
    // get the available transaction types for the selected tab
    var selectedTabMapping = (_a = {},
        _a[EMutualFundOrderTabs.ALL_TRANSACTIONS] = [
            "SIP",
            "STP",
            "SWP",
            "Lumpsum",
            "Redeem",
            "SWITCH",
        ],
        _a[EMutualFundOrderTabs.SIPs] = ["SIP"],
        _a[EMutualFundOrderTabs.STPs] = ["STP"],
        _a[EMutualFundOrderTabs.SWPs] = ["SWP"],
        _a[EMutualFundOrderTabs.MANDATES] = [""],
        _a[EMutualFundOrderTabs.TRANSFER_IN] = [""],
        _a);
    var allowedTrxTypes = selectedTabMapping[selectedTransactionTab];
    var trxType = selectedRowData === null || selectedRowData === void 0 ? void 0 : selectedRowData.trxType;
    var updatedKebabMenuItems = ((_b = transactionTypeTransactionStatusMap[trxType]) === null || _b === void 0 ? void 0 : _b[(_c = selectedRowData === null || selectedRowData === void 0 ? void 0 : selectedRowData.displayStatus) === null || _c === void 0 ? void 0 : _c.toUpperCase()]) || [];
    if (trxType && (allowedTrxTypes === null || allowedTrxTypes === void 0 ? void 0 : allowedTrxTypes.includes(trxType))) {
        return updatedKebabMenuItems;
    }
    return [];
};
export var generateKebabMenuItemsForMandate = function (selectedTransactionTab, enachOrPnach, dpStatus) {
    var _a;
    var _b;
    if (selectedTransactionTab !== EMutualFundOrderTabs.MANDATES)
        return [];
    var mandateTypeStatusMap = (_a = {},
        _a[EDescriptiveMandateType.Digital] = {
            "REGISTRATION PENDING": [AllKebabMenuItems.VIEW_DETAILS],
            "VERIFICATION IN PROGRESS": [AllKebabMenuItems.VIEW_DETAILS],
            ACTIVE: [
                AllKebabMenuItems.VIEW_MANDATE_CALENDAR,
                // AllKebabMenuItems.VIEW_DETAILS,
            ],
            "REGISTRATION FAILED": [AllKebabMenuItems.CREATE_NEW_MANDATE],
            INACTIVE: [AllKebabMenuItems.CREATE_NEW_MANDATE],
            PROCESSING: [AllKebabMenuItems.VIEW_DETAILS],
        },
        _a[EDescriptiveMandateType.Physical] = {
            "DOCUMENT NOT UPLOADED": [AllKebabMenuItems.VIEW_DETAILS],
            "VERIFICATION IN PROGRESS": [AllKebabMenuItems.VIEW_DETAILS],
            ACTIVE: [AllKebabMenuItems.VIEW_MANDATE_CALENDAR],
            CANCELLED: [AllKebabMenuItems.CREATE_NEW_MANDATE],
            "REGISTRATION FAILED": [AllKebabMenuItems.CREATE_NEW_MANDATE],
            INACTIVE: [AllKebabMenuItems.CREATE_NEW_MANDATE],
            PROCESSING: [AllKebabMenuItems.VIEW_DETAILS],
        },
        _a);
    return ((_b = mandateTypeStatusMap[enachOrPnach]) === null || _b === void 0 ? void 0 : _b[dpStatus.toUpperCase()]) || [];
};
export var EMandateTypeValue;
(function (EMandateTypeValue) {
    EMandateTypeValue["N"] = "eNach";
    EMandateTypeValue["X"] = "pNach";
})(EMandateTypeValue || (EMandateTypeValue = {}));
